"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var did_resolver_1 = require("did-resolver");
var uport_lite_1 = __importDefault(require("uport-lite"));
function convertToDid(did, legacy) {
    var publicKey = [{
            id: did + "#keys-1",
            type: 'Secp256k1VerificationKey2018',
            owner: did,
            publicKeyHex: legacy.publicKey.match(/^0x/) ? legacy.publicKey.slice(2) : legacy.publicKey
        }];
    if (legacy.publicEncKey) {
        publicKey.push({
            id: did + "#keys-2",
            type: 'Curve25519EncryptionPublicKey',
            owner: did,
            publicKeyBase64: legacy.publicEncKey
        });
    }
    var doc = {
        '@context': 'https://w3id.org/did/v1',
        id: did,
        publicKey: publicKey,
        authentication: [{
                type: 'Secp256k1SignatureAuthentication2018',
                publicKey: did + "#keys-1"
            }]
    };
    if (legacy.name || legacy.description || legacy.image) {
        var profile = Object.assign({}, legacy);
        delete profile['publicKey'];
        delete profile['publicEncKey'];
        doc.uportProfile = profile;
    }
    return doc;
}
exports.convertToDid = convertToDid;
function register(configured) {
    var cpsRegistry = configured || uport_lite_1.default();
    var registry = function (mnid) { return new Promise(function (resolve, reject) {
        cpsRegistry(mnid, function (error, doc) { return error ? reject(error) : resolve(doc); });
    }); };
    function resolve(did, parsed) {
        return __awaiter(this, void 0, void 0, function () {
            var doc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, registry(parsed.id)];
                    case 1:
                        doc = _a.sent();
                        if (!doc)
                            return [2 /*return*/, null
                                // Check if real DID document or legacy
                            ];
                        // Check if real DID document or legacy
                        if (doc['@context'] === 'https://w3id.org/did/v1')
                            return [2 /*return*/, doc];
                        if (typeof doc['publicKey'] === 'string') {
                            return [2 /*return*/, convertToDid(did, doc)];
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    }
    did_resolver_1.registerMethod('uport', resolve);
}
exports.default = register;
//# sourceMappingURL=register.js.map